import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=64740f74&scoped=true"
import script from "./AlertCard.vue?vue&type=script&lang=js"
export * from "./AlertCard.vue?vue&type=script&lang=js"
import style0 from "./AlertCard.vue?vue&type=style&index=0&id=64740f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64740f74",
  null
  
)

export default component.exports